import { Box, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import WeekChips from './WeekChips'
import { getDateTime } from '../utils'
import { getBookingWindowMaxDate } from './bookingWindowUtils'

type SelectDateProps = {
  now: Date
  date: Date
  setDate: (value: Date) => void
  datesWithSlotAvailability?: string[]
  bookingWindowInHours?: number
}

const SelectDate: FC<SelectDateProps> = ({
  date,
  setDate,
  now,
  datesWithSlotAvailability = [],
  bookingWindowInHours,
}) => {
  const [dateForMonth, setDateForMonth] = useState<Date>(date)

  // Calculate max date based on booking window in hours
  const maxDate = getBookingWindowMaxDate(now, bookingWindowInHours)

  return (
    <>
      <Box
        sx={{
          marginTop: 2,
          marginBottom: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: '2rem',
          }}
        >
          {dateForMonth.toLocaleString('en-EN', { month: 'long' }) +
            ' ' +
            dateForMonth.getFullYear()}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 2,
          marginLeft: -1,
        }}
      >
        <WeekChips
          key={date.toDateString()}
          value={date}
          onChange={changedDate => {
            setDate(getDateTime(changedDate, now))
          }}
          now={now}
          setDateForMonth={setDateForMonth}
          datesWithSlotAvailability={datesWithSlotAvailability}
          maxDate={maxDate}
        />
      </Box>
      <Box
        sx={{
          '& .MuiTextField-root .MuiInputBase-colorPrimary::before': {
            border: 'none',
          },
          '& .MuiTextField-root .MuiInput-root.MuiInputBase-root::after': {
            border: 'none',
          },
          '& .MuiTextField-root input': {
            marginLeft: 1,
          },
          '& .MuiInputAdornment-root': {
            marginLeft: 0,
          },
          '& .MuiPickersInputBase-root': {
            width: '100%',
          },
          '& .MuiFormControl-root': {
            width: '100%',
          },
          marginLeft: -1,
          width: '100%',
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            value={date ?? null}
            format="EEEE, MMMM d"
            onChange={(newDate: Date | null) => {
              if (newDate) {
                setDate(getDateTime(newDate, now))
              }
            }}
            slotProps={{
              textField: {
                // v9 renders the field with its own PickersTextField, whose input is a
                // nested slot rather than MUI TextField's `InputProps`.
                slotProps: {
                  input: {
                    sx: { flexDirection: 'row-reverse' },
                  },
                },
                variant: 'standard', // Apply a specific variant
              },
            }}
            minDate={now}
            maxDate={maxDate}
          />
        </LocalizationProvider>
      </Box>
    </>
  )
}

export default SelectDate
